<template>
    <div class="thumbnail-view bookmark-listing">
        <template v-for="(item, index) in bookmarkState.bookmarkedPages" :key="index">
            <a class="item"
               href="#"
               @click.prevent="gotoBookmarkedPage(item)"
            >
                <img :src="`${bookInfoState.publicPath}/thumbnails/${bookData.pagenames[item]}.jpg`">
                <span class="label"> {{ bookData.pagenames[item] }}</span>
                <delete-bookmark-btn class="btn-delete"
                                     v-show="bookmarkState.isEditing"
                                     :index="index"
                ></delete-bookmark-btn>
            </a>
        </template>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import DeleteBookmarkBtn from "@/views/reader/bookmark/DeleteBookmarkBtn";
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePaging} from "@/modules/reader/book/paging";


    export default {
        components: {
            DeleteBookmarkBtn
        },
        setup(props, context) {

            const { bookData} = useDataLoader();
            const {bookmarkState, deleteBookmark, gotoBookmarkedPage} = useBookmark();
            const { bookInfoState} = useBookInfo();
            const { setCurrentPage} = usePaging();

            return {
                bookData,
                gotoBookmarkedPage,
                bookInfoState,
                bookmarkState,
                deleteBookmark,
                setCurrentPage
            }
        }

    }

</script>

<style scoped lang="scss">

    .thumbnail-view {
        padding:10px;
        display: flex;
        flex-wrap: wrap;

        .item {
            flex: 0 0 50%;
            text-align: center;
            position:relative;
            margin:0 0 20px 0;

            img {
                width: calc(100% - 10px);
                margin: 5px;
            }
        }
    }

    .btn-delete {
        position:absolute;
        right:0;
        top:0;
    }

</style>